"use client"

import { useEffect, useState } from "react"

const LoadingScreen = () => {
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false)
    }, 3000)

    return () => clearTimeout(timer)
  }, [])

  if (!isVisible) return null

  return (
    <div className="fixed inset-0 bg-gradient-to-br from-amber-50 to-orange-100 flex items-center justify-center z-[100] transition-opacity duration-1000">
      <div className="text-center">
        {/* Cooking Pan Animation */}
        <div className="relative mb-8">
          <div className="cooking-pan">
            <div className="pan-handle"></div>
            <div className="pan-body">
              <div className="food-particle food-1"></div>
              <div className="food-particle food-2"></div>
              <div className="food-particle food-3"></div>
              <div className="steam steam-1"></div>
              <div className="steam steam-2"></div>
              <div className="steam steam-3"></div>
            </div>
          </div>
        </div>

        {/* Loading Text */}
        <div className="space-y-4">
          <h2 className="text-3xl font-bold text-amber-700 animate-pulse restaurant-name">Katchit</h2>
          <p className="text-lg text-amber-600 animate-bounce">Preparing your culinary experience...</p>

          {/* Loading Dots */}
          <div className="flex justify-center space-x-2">
            <div className="loading-dot loading-dot-1"></div>
            <div className="loading-dot loading-dot-2"></div>
            <div className="loading-dot loading-dot-3"></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoadingScreen
